import React from "react";
import HeaderModal from "components/modal/HeaderModal";
import { Button, Divider } from "antd";
import IndexModal from "components/modal";
import AnnouncementModal from "../employee-dashboard/components/AnnouncementModal";
import { TIME_FORMAT_12HM } from "variables/constants";
import { displayIcon } from "variables/icons";
import dayjs from "dayjs";

const AnnouncementView = ({ 
  isModalOpen, 
  selectedAnnouncement,
  userType = "client", 
  closeModalHandler,
  selectedColorOption,
}) => {

  return (
    <>
      {userType === "client" && (
        <HeaderModal
          group="announcement"
          open={isModalOpen}
          onClose={closeModalHandler}
          colorTheme="!p-0 backdrop-blur-lg"
          useCustomClass={true}
          descriptionClass="text-2xl text-white font-medium"
          description={selectedAnnouncement.ann_title}
          width={550}
          backgroundStyle={
            <div className="absolute inset-0 pointer-events-none opacity-10">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full -mr-32 -mt-32"></div>
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full -ml-24 -mb-24"></div>
            </div>
          }
          icon={
            <div className="w-16 h-16 rounded-2xl shadow-lg bg-white/20 flex items-center justify-center">
                {displayIcon(selectedAnnouncement.ann_icon, "w-8 h-8 text-white" )}
            </div>
          }
          title={
            <div className="flex items-center gap-2 mb-2">
              <span className="inline-flex items-center justify-center rounded-lg border px-2 py-0.5 font-medium text-[10px] uppercase tracking-wider bg-white/20 border-white/30 text-white">
                {selectedAnnouncement.category_name}
              </span>
              {selectedAnnouncement.priority_level === "High" && (
                <span className="flex items-center gap-1 justify-center rounded-lg px-2 py-0.5 font-medium text-[10px] bg-red-500 text-white">
                  {displayIcon("AlertTriangle", "w-3 h-3 text-white" )} Urgent
                </span>
              )}
              {selectedAnnouncement.priority_level && (
                <span className="rounded-xl border backdrop-blur-sm bg-white/10 text-[10px] px-1 py-0 font-medium text-white">
                  {selectedAnnouncement.priority_level.toLowerCase()} priority
                </span>
              )}
            </div>
          }

          bgcolor={`${selectedColorOption?.gradient || ""}`}
          footer={
            <div className="p-4 inline-flex gap-2 grid grid-cols-1 md:grid-cols-3">
              <Button className="rounded-lg px-4 flex items-center justify-center gap-2 dark:text-white dark:bg-white/10" onClick={closeModalHandler}>
                {displayIcon("X", "w-4 h-4" )} Dismiss
              </Button>
              <Button className="bg-violet-600 text-white rounded-lg flex items-center justify-center col-span-2 gap-2 "  
                      onClick={(e) => {
                        e.stopPropagation();
                        // onRemove(selectedId);
                        closeModalHandler();
                      }}
              >
                {displayIcon("CircleCheck", "w-4 h-4" )} Mark as Read
              </Button>
            </div>
          }
        >
          <div className="space-y-4 pt-4">
            <div>
              <h4 className="text-sm muted-text mb-2 font-semibold">Details</h4>
              <p className="muted-text text-base">
                {selectedAnnouncement.ann_description}
              </p>
            </div>

            <Divider/>

            <div className="grid grid-cols-2 gap-4">
              {selectedAnnouncement.ann_event_date_from && (
                <div className="flex items-center gap-3 p-3 rounded-lg bg-slate-50 dark-mode-card">
                  <div className="p-2 rounded-lg bg-violet-100 dark:bg-violet-600">
                    {displayIcon('Calendar', "w-4 h-4 text-purple-600 dark:text-purple-100")}
                  </div>
                  <div>
                    <p className="text-[10px] muted-text uppercase tracking-wide">Date</p>
                    <p className="text-sm title-text font-semibold">{dayjs(selectedAnnouncement.ann_event_date_from).format("MMM D, YYYY")}</p>
                  </div>
                </div>
              )}

              {selectedAnnouncement.ann_event_time_from && (
                <div className="flex items-center gap-3 p-3 rounded-lg bg-slate-50 dark-mode-card">
                  <div className="p-2 rounded-lg bg-purple-100 dark:bg-violet-600">
                    {displayIcon('Clock', "w-4 h-4 text-purple-600 dark:text-purple-100")}
                  </div>
                  <div>
                    <p className="text-[10px] text-slate-500 dark:text-zinc-500 uppercase tracking-wide">Time</p>
                    <p className="text-sm title-text font-semibold">
                      {dayjs(selectedAnnouncement.ann_event_time_from,["HH:mm"]).format(TIME_FORMAT_12HM)}
                      {selectedAnnouncement?.ann_event_time_to &&
                        ` - 
                      ${dayjs(selectedAnnouncement.ann_event_time_to,["HH:mm"]).format(TIME_FORMAT_12HM)}`}
                    </p>
                  </div>
                </div>
              )}
            </div>
            
            {selectedAnnouncement.ann_additional_info && (
              <div className={`p-4 rounded-lg card-border-s ${selectedColorOption.addInfoCard}`}>
                <div className="flex items-start gap-3">
                  {displayIcon(selectedAnnouncement.ann_icon, "w-5 h-5 icon-color flex-shrink-0")}
                  <div>
                    {selectedAnnouncement.ann_additional_info_label && (
                      <p className="label-color text-sm mb-1 font-semibold">{selectedAnnouncement.ann_additional_info_label}</p>
                    )}
                    <p className="text-color text-xs">
                      {selectedAnnouncement.ann_additional_info}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

  
        </HeaderModal>
      )}

      {userType === "employee" && (
        <IndexModal
          open={isModalOpen}
          onClose={closeModalHandler}
          useCustomClass={true}
          maxContentHeight="298px"
          width="500px"
        >
          <AnnouncementModal 
            announcement={selectedAnnouncement}
            onClose={closeModalHandler}
          />
        </IndexModal>
      )}
    </>
  )
};

export default AnnouncementView;
